<!-- Page Header -->
@if (!isEmbedded) {
  <app-page-header></app-page-header>
}

<div class="advanced-search-container" [class.embedded]="isEmbedded">
  <div [class.container]="!isEmbedded" [class.py-4]="!isEmbedded">
    <div class="card border-0 shadow-sm" [class.border-0]="isEmbedded" [class.shadow-none]="isEmbedded">
      @if (!isEmbedded) {
        <div class="card-header bg-primary text-white">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">
              <i class="fas fa-search-plus me-2"></i>
              {{ 'ADVANCED_SEARCH_TITLE' | translate }}
            </h5>
            <a [routerLink]="['/']" class="btn btn-sm btn-light">
              <i class="fas fa-home me-1"></i>
              {{ 'BACK_TO_HOME' | translate }}
            </a>
          </div>
        </div>
      }

      <div class="card-body">
        <!-- Search Fields -->
        <div class="search-fields mb-4">
          @for (field of searchFields; track field; let i = $index) {
            <div class="search-field-row mb-3">
              <div class="row g-2 align-items-center">
                <!-- Operator (except first row) -->
                @if (i > 0) {
                  <div class="col-auto" style="width: 80px;">
                    <select class="form-select form-select-sm" [(ngModel)]="field.operator">
                      @for (op of searchOperators; track op) {
                        <option [value]="op.value">
                          {{ op.label | translate }}
                        </option>
                      }
                    </select>
                  </div>
                }
                @if (i === 0) {
                  <div class="col-auto" style="width: 80px;">
                    <!-- Empty space for alignment -->
                  </div>
                }
                <!-- Search Text -->
                <div class="col">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    [(ngModel)]="field.text"
                    [placeholder]="'SEARCH_PLACEHOLDER' | translate">
                  </div>
                  <!-- Scope Selector -->
                  <div class="col-auto" style="width: 150px;">
                    <select class="form-select form-select-sm" [(ngModel)]="field.scope">
                      @for (scope of searchScopes; track scope) {
                        <option [value]="scope.value">
                          {{ scope.label | translate }}
                        </option>
                      }
                    </select>
                  </div>
                  <!-- Remove Button -->
                  <div class="col-auto">
                    @if (searchFields.length > 1) {
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        (click)="removeSearchField(i)">
                        <i class="fas fa-times"></i>
                      </button>
                    }
                  </div>
                </div>
              </div>
            }

            <!-- Add Field Button -->
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              (click)="addSearchField()">
              <i class="fas fa-plus me-1"></i>
              {{ 'SEARCH_ADD_FIELD' | translate }}
            </button>
          </div>

          <hr>

            <!-- Filters -->
            <div class="filters-section">
              <h6 class="mb-3">{{ 'SEARCH_FILTERS' | translate }}</h6>

              <div class="row g-3">
                <!-- Year Range -->
                <div class="col-md-6">
                  <label class="form-label small fw-bold">{{ 'SEARCH_YEAR_RANGE' | translate }}</label>
                  <div class="row g-2">
                    <div class="col">
                      <input
                        type="number"
                        class="form-control form-control-sm"
                        [(ngModel)]="selectedYearRange.from"
                        [placeholder]="'SEARCH_YEAR_FROM' | translate"
                        min="1900"
                        [max]="selectedYearRange.to || 2100">
                      </div>
                      <div class="col-auto d-flex align-items-center">
                        <span>-</span>
                      </div>
                      <div class="col">
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          [(ngModel)]="selectedYearRange.to"
                          [placeholder]="'SEARCH_YEAR_TO' | translate"
                          [min]="selectedYearRange.from || 1900"
                          max="2100">
                        </div>
                      </div>
                    </div>

                    <!-- Languages -->
                    <div class="col-md-6">
                      <label class="form-label small fw-bold">{{ 'SEARCH_LANGUAGE' | translate }}</label>
                      <div class="language-options">
                        @for (lang of languages; track lang) {
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [id]="'lang-' + lang.value"
                              [checked]="selectedLanguages.includes(lang.value)"
                              (change)="toggleLanguage(lang.value)">
                              <label class="form-check-label" [for]="'lang-' + lang.value">
                                {{ lang.label | translate }}
                              </label>
                            </div>
                          }
                        </div>
                      </div>

                      <!-- Sort Options -->
                      <div class="col-md-6">
                        <label class="form-label small fw-bold">{{ 'SEARCH_SORT_BY' | translate }}</label>
                        <div class="row g-2">
                          <div class="col-8">
                            <select class="form-select form-select-sm" [(ngModel)]="selectedSortOption">
                              @for (sort of sortOptions; track sort) {
                                <option [value]="sort.value">
                                  {{ sort.label | translate }}
                                </option>
                              }
                            </select>
                          </div>
                          <div class="col-4">
                            <select class="form-select form-select-sm" [(ngModel)]="selectedSortDirection">
                              <option value="desc">{{ 'SORT_DESC' | translate }}</option>
                              <option value="asc">{{ 'SORT_ASC' | translate }}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr>

                    <!-- Action Buttons -->
                    <div class="d-flex justify-content-end gap-2">
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        (click)="resetSearch()">
                        <i class="fas fa-redo me-1"></i>
                        {{ 'SEARCH_RESET' | translate }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        (click)="search()">
                        <i class="fas fa-search me-1"></i>
                        {{ 'SEARCH_SUBMIT' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Footer -->
              @if (!isEmbedded) {
                <app-footer></app-footer>
              }
